import { useCallback, useMemo, useState } from 'react';

import { ExecutionFeed } from '@/components/execution-feed';
import { FirstRunSetup } from '@/components/first-run-setup';
import { SETUP_CHECKLIST_DISMISSED_KEY } from '@/lib/first-run-keys';
import { useExecutionStore } from '@/lib/storage/provider';

export function DashboardHomeClient({
  projects,
}: {
  projects: { id: string; name: string; agentUrl: string | null }[];
}): import('react/jsx-runtime').JSX.Element {
  const { executions, isLoading } = useExecutionStore();
  const [dismissed, setDismissed] = useState(() => {
    try {
      return globalThis.localStorage?.getItem(SETUP_CHECKLIST_DISMISSED_KEY) === '1';
    } catch {
      return false;
    }
  });

  const onDismiss = useCallback((): void => {
    try {
      globalThis.localStorage?.setItem(SETUP_CHECKLIST_DISMISSED_KEY, '1');
    } catch {
      // ignore
    }
    setDismissed(true);
  }, []);

  const projectSummaries = useMemo(
    (): { id: string; name: string }[] =>
      projects.map((p): { id: string; name: string } => ({ id: p.id, name: p.name })),
    [projects],
  );

  const missionVisible = projects.length > 0 && !isLoading && executions.length === 0 && !dismissed;

  return (
    <div className="space-y-8">
      <FirstRunSetup projects={projectSummaries} dismissed={dismissed} onDismiss={onDismiss} />
      <ExecutionFeed projects={projects} suppressGettingStarted={missionVisible} />
    </div>
  );
}
